module.exports = __webpack_public_path__ + "static/media/Beneficary_Transfer.3ce7e732.svg";